import React from 'react';

import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import { HeaderText, SecondaryText } from 'apps/auth/components/common/Layout/InfoPage/styles';
import { IntroBlock, IntroBlockImg } from 'apps/auth/components/common/Layout/MainColumn/styles';
import { URL_IMAGES_I } from 'apps/auth/constants/UrlConstants';
import { usePageMessages } from 'apps/auth/hooks/selectors';
import { useThemeDetector } from 'apps/auth/hooks/theme';

const EmptyAccountsLibre = () => {
    const { libreEmptyAccountsTitle, libreEmptyAccountsText } = usePageMessages();

    const { theme } = useThemeDetector();

    return (
        <IntroBlock>
            <IntroBlockImg>
                <img src={`${URL_IMAGES_I}/empty-accounts-libre${theme === 'dark' ? '-dark' : '-light'}.svg`} alt="empty-accounts-libre" />
            </IntroBlockImg>
            <HeaderText>{libreEmptyAccountsTitle}</HeaderText>
            <SecondaryText>
                <DangerouslyHtml dangerouslyHtml={libreEmptyAccountsText} />
            </SecondaryText>
        </IntroBlock>
    );
};

export default EmptyAccountsLibre;
